import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  style: {"height":"100%"},
  align: "Center"
}
const _hoisted_2 = { id: "overall-body" }
const _hoisted_3 = {
  id: "body-container",
  align: "left"
}
const _hoisted_4 = {
  id: "body-table",
  cellspacing: "0",
  cellpadding: "0"
}
const _hoisted_5 = { id: "main-container" }
const _hoisted_6 = {
  width: "100%",
  cellspacing: "5",
  cellpadding: "0",
  border: "0"
}
const _hoisted_7 = { valign: "top" }
const _hoisted_8 = {
  valign: "top",
  align: "left"
}
const _hoisted_9 = { class: "full-width" }
const _hoisted_10 = { style: {"border":"1px solid black","padding":"10px","margin":"0 2rem"} }
const _hoisted_11 = {
  class: "top-align-left-column",
  width: "100%",
  cellspacing: "0",
  cellpadding: "0",
  border: "0"
}
const _hoisted_12 = { style: {"border":"1px solid black","padding":"10px","margin":"0.5rem 2rem"} }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { style: {"margin":"10px 0"} }
const _hoisted_16 = { style: {"min-height":"75px","display":"flex"} }
const _hoisted_17 = { style: {"height":"75px","font-weight":"bold"} }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { key: 1 }
const _hoisted_20 = { style: {"margin-left":"10px","padding":"10px 40px"} }
const _hoisted_21 = { width: "100%" }
const _hoisted_22 = { width: "60%" }
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.$store.getters.isInternalUser)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("table", _hoisted_4, [
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("td", _hoisted_5, [
                    _createElementVNode("table", _hoisted_6, [
                      _createElementVNode("tbody", null, [
                        _createElementVNode("tr", _hoisted_7, [
                          _createElementVNode("td", _hoisted_8, [
                            _createElementVNode("div", _hoisted_9, [
                              _cache[23] || (_cache[23] = _createStaticVNode("<div class=\"grid\" data-v-884448a0><div class=\"col-8\" data-v-884448a0></div><div class=\"col-4\" data-v-884448a0><div class=\"col css-image compass-logo\" style=\"height:50px;\" data-v-884448a0></div></div></div><div style=\"margin:10px 0;text-align:center;\" data-v-884448a0><span style=\"text-transform:uppercase;font-weight:bold;font-size:18px;letter-spacing:1px;\" data-v-884448a0> Certificate of compliance with inspection,<br data-v-884448a0> maintenance and reporting procedures </span><br data-v-884448a0><span style=\"font-style:italic;font-weight:bold;\" data-v-884448a0>Section 108 (3)(c) Building Act 2004</span><br data-v-884448a0><strong data-v-884448a0>FORM 12A</strong></div>", 2)),
                              _cache[24] || (_cache[24] = _createElementVNode("div", { style: {"border":"1px solid black","padding":"5px","margin":"0.5rem 2rem"} }, [
                                _createElementVNode("table", {
                                  width: "100%",
                                  cellspacing: "0",
                                  cellpadding: "0",
                                  border: "0"
                                }, [
                                  _createElementVNode("tbody", null, [
                                    _createElementVNode("tr", null, [
                                      _createElementVNode("td", {
                                        width: "60%",
                                        valign: "top"
                                      }, "Certificate issued by"),
                                      _createElementVNode("td", null, [
                                        _createElementVNode("strong", null, [
                                          _createTextVNode(" Compass New Zealand Ltd"),
                                          _createElementVNode("br"),
                                          _createTextVNode(" Unit 2J, 3 Ceres Court, Rosedale, Auckland ")
                                        ])
                                      ])
                                    ])
                                  ])
                                ])
                              ], -1)),
                              _createElementVNode("div", _hoisted_10, [
                                _createElementVNode("table", _hoisted_11, [
                                  _createElementVNode("tbody", null, [
                                    _cache[12] || (_cache[12] = _createElementVNode("tr", null, [
                                      _createElementVNode("td", {
                                        colspan: "2",
                                        class: "title"
                                      }, "The Building")
                                    ], -1)),
                                    _createElementVNode("tr", null, [
                                      _cache[0] || (_cache[0] = _createElementVNode("td", null, "Compliance Schedule No:", -1)),
                                      _createElementVNode("td", null, _toDisplayString(_ctx.bwof.complianceSchedule), 1)
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _cache[1] || (_cache[1] = _createElementVNode("td", null, "Street Address of Building:", -1)),
                                      _createElementVNode("td", null, _toDisplayString(_ctx.propertyData.streetAddress) + " " + _toDisplayString(_ctx.propertyData.suburb) + " " + _toDisplayString(_ctx.propertyData.city), 1)
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _cache[2] || (_cache[2] = _createElementVNode("td", null, "Legal Description:", -1)),
                                      _createElementVNode("td", null, _toDisplayString(_ctx.bwof.legalDescription), 1)
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _cache[3] || (_cache[3] = _createElementVNode("td", null, "Building Name:", -1)),
                                      _createElementVNode("td", null, _toDisplayString(_ctx.propertyData.buildingName), 1)
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _cache[4] || (_cache[4] = _createElementVNode("td", null, "Location of Building within site/block number:", -1)),
                                      _createElementVNode("td", null, _toDisplayString(_ctx.bwof.locationOfBuildingWithinSite), 1)
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _cache[5] || (_cache[5] = _createElementVNode("td", null, "Level/Unit Number:", -1)),
                                      _createElementVNode("td", null, _toDisplayString(_ctx.bwof.levelUnitNo), 1)
                                    ]),
                                    _cache[13] || (_cache[13] = _createElementVNode("tr", null, [
                                      _createElementVNode("td", { colspan: "2" }, " ")
                                    ], -1)),
                                    _cache[14] || (_cache[14] = _createElementVNode("tr", null, [
                                      _createElementVNode("td", {
                                        colspan: "2",
                                        class: "title"
                                      }, "The Owner")
                                    ], -1)),
                                    _createElementVNode("tr", null, [
                                      _cache[6] || (_cache[6] = _createElementVNode("td", null, "Name of Owner:", -1)),
                                      _createElementVNode("td", null, _toDisplayString(_ctx.owner.companyName), 1)
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _cache[7] || (_cache[7] = _createElementVNode("td", null, "Contact Person:", -1)),
                                      _createElementVNode("td", null, _toDisplayString(_ctx.ownerContact.firstName) + " " + _toDisplayString(_ctx.ownerContact.lastName), 1)
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _cache[8] || (_cache[8] = _createElementVNode("td", null, "Mailing Address:", -1)),
                                      _createElementVNode("td", null, _toDisplayString(_ctx.owner.postalAddress) + " " + _toDisplayString(_ctx.owner.suburb) + " " + _toDisplayString(_ctx.owner.city), 1)
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _cache[9] || (_cache[9] = _createElementVNode("td", null, "Street Address:", -1)),
                                      _createElementVNode("td", null, _toDisplayString(_ctx.owner.streetAddress), 1)
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _cache[10] || (_cache[10] = _createElementVNode("td", null, "Email Address:", -1)),
                                      _createElementVNode("td", null, _toDisplayString(_ctx.ownerContact.email), 1)
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _cache[11] || (_cache[11] = _createElementVNode("td", null, "Contact Number:", -1)),
                                      _createElementVNode("td", null, _toDisplayString(_ctx.ownerContact.ddi && _ctx.ownerContact.ddi.trim() !== '' ? _ctx.ownerContact.ddi : _ctx.ownerContact.mobile), 1)
                                    ])
                                  ])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_12, [
                                _cache[20] || (_cache[20] = _createTextVNode(" Compass New Zealand Ltd certifies that the inspection, maintenance and reporting procedures of the Compliance Schedule have been fully complied with during the ", -1)),
                                (_ctx.bwof.complianceScheduleMonths == 1)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_ctx.bwof.complianceScheduleMonths) + " month", 1))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(_ctx.bwof.complianceScheduleMonths) + " months", 1)),
                                _cache[21] || (_cache[21] = _createTextVNode(" prior to the date stated below in relation to the following specified system/s: ", -1)),
                                _cache[22] || (_cache[22] = _createElementVNode("br", null, null, -1)),
                                _createElementVNode("div", _hoisted_15, [
                                  _createElementVNode("table", _hoisted_16, [
                                    _createElementVNode("tbody", null, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleServices, (srv) => {
                                        return (_openBlock(), _createElementBlock("tr", {
                                          key: srv.serviceId
                                        }, [
                                          _createElementVNode("td", null, [
                                            _createElementVNode("span", null, _toDisplayString(srv.ref), 1)
                                          ]),
                                          _createElementVNode("td", null, _toDisplayString(srv.serviceName), 1)
                                        ]))
                                      }), 128))
                                    ])
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_17, [
                                  _cache[15] || (_cache[15] = _createTextVNode(" SIGNATURE OF IQP # ", -1)),
                                  (_ctx.bwof.issuedBy == 'John')
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_18, "110474"))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_19, "110459")),
                                  _cache[16] || (_cache[16] = _createTextVNode(": ", -1)),
                                  _createElementVNode("div", _hoisted_20, [
                                    _createElementVNode("div", {
                                      class: _normalizeClass(["document-text-border col mr-4 mt-1 css-image", [_ctx.bwof.issuedBy == 'John' ? 'signature-john':'signature-keith' ]]),
                                      style: {"height":"30px"}
                                    }, null, 2)
                                  ])
                                ]),
                                _createElementVNode("div", null, [
                                  _createElementVNode("table", _hoisted_21, [
                                    _createElementVNode("tbody", null, [
                                      _createElementVNode("tr", null, [
                                        _createElementVNode("td", _hoisted_22, [
                                          _cache[17] || (_cache[17] = _createElementVNode("strong", null, "NAME:", -1)),
                                          _cache[18] || (_cache[18] = _createTextVNode()),
                                          (_ctx.bwof.issuedBy == 'John')
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_23, "John Bell"))
                                            : (_openBlock(), _createElementBlock("span", _hoisted_24, "Keith Flatt"))
                                        ]),
                                        _createElementVNode("td", null, [
                                          _cache[19] || (_cache[19] = _createElementVNode("strong", null, "DATE:", -1)),
                                          _createTextVNode(" " + _toDisplayString(_ctx.formattedDate(_ctx.issuedDate)), 1)
                                        ])
                                      ])
                                    ])
                                  ])
                                ])
                              ])
                            ])
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}